import { PLOT_CHECKBOX_UPDATE, PLOT_CHECKBOX_UPDATE_ALL, PLOT_CHECKBOX_CLEAR_ALL } from '../reducers/country/plot/controls/dataShown/checkbox/legacy/plotCheckboxes';
export function updatePlotCheckbox(plotId, checkboxId, checked) {
  return {
    type: PLOT_CHECKBOX_UPDATE,
    plotId: plotId,
    checkboxId: checkboxId,
    checked: checked
  };
}
export function updatePlotCheckboxes(plotId, checkedIdMap) {
  return {
    type: PLOT_CHECKBOX_UPDATE_ALL,
    plotId: plotId,
    checkedIdMap: checkedIdMap
  };
}
export function clearPlotCheckboxes(plotId) {
  return {
    type: PLOT_CHECKBOX_CLEAR_ALL,
    plotId: plotId
  };
}